<div class="content">
  <div class="modal-header">
    <h4 class="modal-title full-width ">
      {{ 'LABELS.SELECT_PAYMENT_METHOD' | translate }}
    </h4>
    <button type="button" class="close invoice-timeline-view-close-btn" aria-label="Close"
      (click)="activeModal?.dismiss(null)">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col">
        <!-- Payment Methods Table (excluding CF) -->
        <div class="table-responsive" style="height: 400px;">
          <table class="table table-centered border table-nowrap mb-lg-0"
            *ngFor="let item of data.payData.paymentOptionsMap | keyvalue">
            <ng-container *ngIf="item.key !== 'CF'">
              <thead>
                <ng-container *ngIf="item.key === 'NEFT'">
                  <tr>
                    <td colspan="3" class="text-start">{{item.value[0].title}}</td>
                    <td class="text-end action-column">
                      <button type="button" class="btn  fis-btn btn-sm"
                        (click)="selectPaymentOption(item.value[0])">{{'LABELS.SELECT' | translate}}</button>
                    </td>
                  </tr>
                </ng-container>
                
                <tr *ngIf="item.key === 'XiCheck'">
                  <th class="text-start">{{'LABELS.ACCOUNT_NUMBER'|translate}} </th>
                  <th class="text-start">{{'LABELS.BANK_NAME'|translate}}</th>
                  <th class="text-start">{{'LABELS.NAME_ON_ACCOUNT'|translate}}</th>
                  <th class="text-start">{{'LABELS.ROUTING_NUMBER'|translate}}</th>
                  <th class="text-end action-column-header"></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngIf="item.key === 'XiCard'">
                  <th class="text-start">{{'LABELS.CARD_TYPE'|translate}}</th>
                  <th class="text-start">{{'LABELS.CARDHOLDERS_NAME'|translate}}</th>
                  <th class="text-start">{{'LABELS.CARD_NUMBER'|translate}}</th>
                  <th class="text-start">{{'LABELS.EXPIRATION'|translate}}</th>
                  <th class="text-end action-column-header"></th>
                </tr>
                <tr *ngFor="let payOption of item.value">
                  <ng-container *ngIf="item.key === 'XiCard'">
                    <td class="pe-0" class="text-start">
                      <i class="fab {{payOption.icon}}" style="font-size: 32px; color: black;"></i>
                    </td>
                    <td class="text-start">
                      {{payOption.name}}
                    </td>
                    <td class="text-start">
                      XXXX - XXXX - XXXX - {{payOption.cardLastFourDigit}}
                    </td>
                    <td class="text-start">
                      <span *ngIf="(payOption.expMonth <10); else greaterThanTen"> 0{{payOption.expMonth}} /
                        {{payOption.expYear}}</span>
                      <ng-template #greaterThanTen> {{payOption.expMonth}} / {{payOption.expYear}} </ng-template>
                    </td>

                    <td class="text-end action-column">
                      <button type="button" class="btn  fis-btn btn-sm"
                        (click)="selectPaymentOption(payOption)">{{'LABELS.SELECT' | translate}}</button>
                    </td>
                  </ng-container>
                  <ng-container *ngIf="item.key === 'XiCheck'">
                    <td class="text-start">
                      {{payOption.title | ellipsis:10}}
                      <a *ngIf="payOption.title && payOption.title.length > 10" href="javascript:;" placement="right"
                        [ngbPopover]="popContent0">
                        <i class="fa fa-info-circle"></i>
                      </a>
                      <ng-template #popContent0>
                        <div style="max-height: 250px; overflow: auto;">
                          {{payOption.title}}
                        </div>
                      </ng-template>
                    </td>
                    <td class="text-start">
                      {{payOption.bankName | ellipsis:10}}
                      <a *ngIf="payOption.bankName && payOption.bankName.length > 10" href="javascript:;"
                        placement="right" [ngbPopover]="popContent1">
                        <i class="fa fa-info-circle"></i>
                      </a>
                      <ng-template #popContent1>
                        <div style="max-height: 250px; overflow: auto;">
                          {{payOption.bankName}}
                        </div>
                      </ng-template>
                    </td>
                    <td class="text-start">
                      {{payOption.nameOnAccount | ellipsis:10}}
                      <a *ngIf="payOption.nameOnAccount && payOption.nameOnAccount.length > 10" href="javascript:;"
                        placement="right" [ngbPopover]="popContent2">
                        <i class="fa fa-info-circle"></i>
                      </a>
                      <ng-template #popContent2>
                        <div style="max-height: 250px; overflow: auto;">
                          {{payOption.nameOnAccount}}
                        </div>
                      </ng-template>
                    </td>
                    <td class="text-start">
                      {{payOption.routingNumber | ellipsis:10}}
                      <a *ngIf="payOption.routingNumber && payOption.routingNumber.length > 10" href="javascript:;"
                        placement="right" [ngbPopover]="popContent3">
                        <i class="fa fa-info-circle"></i>
                      </a>
                      <ng-template #popContent3>
                        <div style="max-height: 250px; overflow: auto;">
                          {{payOption.routingNumber}}
                        </div>
                      </ng-template>
                    </td>
                    <td class="text-end action-column">
                      <button type="button" class="btn  fis-btn btn-sm"
                        (click)="selectPaymentOption(payOption)">{{'LABELS.SELECT' | translate}}</button>
                    </td>
                  </ng-container>
                  <ng-container *ngIf="item.key !== 'NEFT' && item.key !== 'XiCard' && item.key !== 'XiCheck'">
                    <td colspan="6" class="text-start">
                      {{payOption.title}}
                    </td>
                    <td colspan="6" class="text-start">
                      {{payOption.bankName}}
                    </td>
                    <td colspan="6" class="text-start">
                      {{payOption.nameOnAccount}}
                    </td>
                    <td colspan="6" class="text-start">
                      {{payOption.routingNumber}}
                    </td>
                    <td class="text-end action-column">
                      <button type="button" class="btn  fis-btn btn-sm"
                        (click)="selectPaymentOption(payOption)">{{'LABELS.SELECT' | translate}}</button>
                    </td>
                  </ng-container>
                </tr>
              </tbody>
            </ng-container>
          </table>
        </div>

        <!-- Channel Finance Section (Separate Card Layout) -->
        <div class="cf-payment-section" *ngIf="data.payData.paymentOptionsMap && data.payData.paymentOptionsMap['CF'] && data.payData.paymentOptionsMap['CF'].length">
          <div class="cf-section-header">
            <h5 class="mb-0">Channel Finance</h5>
          </div>
          <div class="cf-cards-container">
            <div class="cf-card" *ngFor="let payOption of data.payData.paymentOptionsMap['CF']">
              <div class="cf-card-header">
                <h6 class="cf-lender-name">{{payOption.lenderName}}</h6>
              </div>
              <div class="cf-card-body">
                <div class="cf-details-grid">
                  <div class="cf-detail-item">
                    <span class="cf-detail-label">Total Credit</span>
                    <span class="cf-detail-value">{{payOption.totalCredit | cpgcurrency: (data.payData?.invoiceData?.currCode || 'INR')}}</span>
                  </div>
                  <div class="cf-detail-item">
                    <span class="cf-detail-label">Amount Utilized</span>
                    <span class="cf-detail-value">{{payOption.amountUtilization | cpgcurrency: (data.payData?.invoiceData?.currCode || 'INR')}}</span>
                  </div>
                  <div class="cf-detail-item">
                    <span class="cf-detail-label">Available Balance</span>
                    <span class="cf-detail-value cf-highlight">{{payOption.availableCredit | cpgcurrency: (data.payData?.invoiceData?.currCode || 'INR')}}</span>
                  </div>
                  <div class="cf-detail-item">
                    <span class="cf-detail-label">Rate of Interest</span>
                    <span class="cf-detail-value">{{payOption.rateOfInterest}}%</span>
                  </div>
                  <div class="cf-detail-item">
                    <span class="cf-detail-label">Processing Fees</span>
                    <span class="cf-detail-value">{{payOption.processingFees}}%</span>
                  </div>
                  <div class="cf-detail-item">
                    <span class="cf-detail-label">Late Payment Charges</span>
                    <span class="cf-detail-value">{{payOption.latePaymentCharges}}%</span>
                  </div>
                </div>
              </div>
              <div class="cf-card-footer">
                <button type="button" class="btn fis-btn cf-select-btn"
                  (click)="selectPaymentOption(payOption)">{{'LABELS.SELECT' | translate}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="card-disabled" *ngIf="loading">
    <div class="card-portlets-loader">
      <div class="spinner-border text-primary m-2" role="status"></div>
    </div>
  </div>
</div>